import React from 'react';
import { /* MdClose, */ MdTune } from 'react-icons/md';

const LocationBlockedCard = () => {
    return (
        <div className="w-full flex items-center justify-center bg-gray-50/50 py-8 px-4 rounded-xl border-2 border-dashed border-gray-200">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden animate-in fade-in zoom-in duration-300">
                <div className="p-1 bgColor-primary-50 flex justify-end">
                </div>
                
                <div className="px-6 md:px-8 pb-10 pt-4 flex flex-col items-center">
                    {/* Browser Mockup Illustration */}
                    <div className="w-full mb-8 relative">
                        <div className="w-full h-32 bg-gray-50 rounded-lg border border-gray-200 overflow-hidden relative shadow-inner">
                            {/* Browser Bars */}
                            <div className="h-8 bg-gray-100 border-b border-gray-200 flex items-center px-3 space-x-2">
                                <div className="flex space-x-1">
                                    <div className="w-2 h-2 rounded-full bg-red-400"></div>
                                    <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                                    <div className="w-2 h-2 rounded-full bg-green-400"></div>
                                </div>
                                <div className="flex-1 bg-white h-5 rounded-md border border-gray-200 flex items-center px-2 relative">
                                    <div className="p-0.5 bg-blue-50 text-blue-600 rounded mr-2 animate-pulse shadow-sm">
                                        <MdTune size={12} />
                                    </div>
                                    <div className="w-24 h-2 bg-gray-100 rounded"></div>
                                    
                                    {/* Mouse Pointer Animation */}
                                    <div className="absolute top-2 left-2 pointer-events-none animate-bounce">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="black" className="shadow-lg">
                                            <path d="M7 2l12 11.2l-5.8 0.5l3.3 7.3l-2.2 1l-3.2-7.4L7 19z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Permission Dialog Mockup */}
                            <div className="absolute top-9 left-2 w-40 bg-white border border-gray-200 rounded-lg shadow-xl p-3 transform scale-90 origin-top-left animate-in slide-in-from-top-2 duration-500">
                                <div className="flex items-center space-x-2 mb-2 pb-2 border-b border-gray-100">
                                    <div className="p-1 bg-blue-50 text-blue-600 rounded">
                                        <MdTune size={10} />
                                    </div>
                                    <div className="w-16 h-1.5 bg-gray-200 rounded"></div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <div className="w-12 h-2 bg-gray-700 rounded"></div>
                                    <div className="w-6 h-3 bg-blue-600 rounded-full flex items-center px-0.5 justify-end">
                                        <div className="w-2 h-2 bg-white rounded-full"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 className="text-xl font-bold text-gray-900 mb-4 text-center">
                        Punching is blocked from using your location
                    </h2>
                    
                    <div className="space-y-4 w-full">
                        <div className="flex items-start space-x-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-bold mt-0.5">
                                1
                            </div>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Click the <span className="inline-flex items-center  font-semibold text-gray-800 bg-gray-100 px-1 rounded"><MdTune className="mr-1 shadow-sm" size={14}/> tune or lock icon</span> in your browser's address bar
                            </p>
                        </div>
                        
                        <div className="flex items-start space-x-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-bold mt-0.5">
                                2
                            </div>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                Turn on <span className="font-semibold text-gray-800">Location</span> access for this site
                            </p>
                        </div>

                        <div className="mt-6 pt-6 border-t border-gray-100">
                            <p className="text-xs text-center text-gray-400 italic">
                                Once enabled, the page will automatically refresh or you can click 'Grant Access' below.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationBlockedCard;
